module.exports = __webpack_public_path__ + "media/images/zamani-cash-591d640f5480ef8b2b41d2852878a65c.png";